
<div class="overlay" *ngIf="isLoading | async">
    <mat-progress-spinner class="spinner" [color]="color" mode="indeterminate" [value]="value">
    </mat-progress-spinner>
</div>